import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth, atLeast } from "./lib/auth";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Devices from "./pages/Devices";
import DeviceDetail from "./pages/DeviceDetail";
import Tickets from "./pages/Tickets";
import Alerts from "./pages/Alerts";
import Admin from "./pages/Admin";
import type { ReactElement } from "react";

function RequireAuth({ children }: { children: ReactElement }) {
  const { staff } = useAuth();
  if (!staff) return <Navigate to="/login" replace />;
  return children;
}

function RequireAdmin({ children }: { children: ReactElement }) {
  const { staff } = useAuth();
  if (!staff) return <Navigate to="/login" replace />;
  if (!atLeast(staff.role, "super_admin")) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="devices" element={<Devices />} />
        <Route path="devices/:id" element={<DeviceDetail />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="alerts" element={<Alerts />} />
        <Route
          path="admin"
          element={
            <RequireAdmin>
              <Admin />
            </RequireAdmin>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
